import { ShopContainer } from "../ShopContainer";
import {DrwKind, isDrwDefault} from "./drwDefaultElevation";
import {DrwDoorThermalCheckbox} from "./DrwDoorThermalCheckbox";
import {api} from "../../../../api/API";
import {adoptHardwareElevation} from "./adoptHardwareElevation";
import {useConfirm} from "../../../../misc/Confirm";
import {useTabQueryParam} from "../../../../misc/userpref/useTabQueryParam";
import {useProjectId, useProjectUnitSystem} from "../ProjectName";
import {useNavigate} from "react-router-dom";
import {hardwareElevationToolUrl, openElevation} from "./elevationToolLink";
import {Opening} from "../../../../api/Openings";
import React, {useContext, useState} from "react";
import { RowActions } from "./RowActions";
import {
    actionsColName,
    AdjustCol,
    DistanceCol, NominalWidth,
    NumberCol,
    Select2Col, SelectCol,
    StringCol,
    Table, SeqNumber, Column, lookupNestedProp, sortStringInner, GenericStatusCol, RenderStringCol2, makeSelectWrapper
} from "../../../../misc/scroller/Table";
import {blue, cyan, deepOrange, green, grey, indigo, lime, orange, purple, red} from "@mui/material/colors";
import {EditHardwareGroup} from "./EditHardwareGroup";
import {useUser} from "../../../../misc/Permission";
import {ManagerLockContext, ProjectActions} from "../ProjectActions";
import {MakeSubmittal} from "./MakeSubmittal";
import {ProjectProperties, ProjectPropertiesContext, ProjectPropertiesProvider} from "../ProjectProperties";
import {AutoInsertOpening} from "./AutoInsertOpening";
import {
    AnchorCol,
    doorGauge, doorThicknesses, frameConstruction, frameGauge, frameMaterial,
    handingOptions, isWindow, JambDepthCol,
    locationTransitions,
    openingTypes, updateFrameProfileBasedOnHanding, validateDoorThickness, cleanDoorThickness
} from "../../quote/openings/QuoteOpenings";
import {PrepLocations} from "../../quote/openings/PrepLocations";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {doorSeries, frameSeries,labels,} from "../../quote/openings/Const"
import {CircularProgress, Grid, Tab, Tabs, Tooltip} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import StorefrontIcon from "@mui/icons-material/Storefront";
import {HeaderActionButton} from "../HeaderActionButton";
import {ManageProjectSuppliers} from "../hardware/ManageProjectSuppliers";
import {SupplierProvider} from "../hardware/SupplierContext";
import {MenuButton} from "../../../logistics/purchasing/MenuButton";
import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import {OpenInNew, ChangeCircleOutlined, NoteAddOutlined} from "@mui/icons-material";
import {TabWrapper} from "../TabWrapper";
import {useQueryParam} from "../../quote/pricing/QueryParam";
import {OpeningSwitcher} from "./OpeningSwitcher";
import { WithChangesetMeta} from "../changeset/ChangesetContext";
import {cellInActive} from "../pricing/cellconst";
import {PreviousValuePopup} from "./PreviousValuePopup";
import {ScreenElevationPopup} from "../../quote/openings/ScreenElevationPopup";
import {ChangePreviewContext} from "../ShopDrawingChangePreview";
import {NewRowMenu} from "../../quote/openings/NewRowMenu";
import {BreakHardwareLinkContext, BreakHardwareLinkProvider} from "../../quote/openings/BreakHardwareLinkProvider";
import {ConfirmWallTypeUpdateProvider, useConfirmWallTypeUpdate} from "./ConfirmWallTypeUpdateProvider";
import {ConfirmSharedIdentityProvider, useConfirmSharedIdentity} from "./ConfirmSharedIdentityProvider";
import {ConfirmAdoptIdentityProvider, useConfirmAdoptIdentity} from "./ConfirmAdoptIdentityProvider";
import {errShowNoSnackInTable} from "../../../../misc/scroller/EditProvider";
import {projectTablePrefName} from "../TablePrefName";
import {DrawingWallLabelPopup} from "../../quote/openings/DrawingWallLabelPopup";
import {TextEditCell} from "../../quote/openings/TextEditCell";
import {ReviewWallTypes, ReviewWallTypeTitle} from "../../quote/openings/ReviewWallTypes";
import {ReviewScreenElevations, ReviewScreenElevationTitle} from "../../quote/openings/ReviewScreenElevations";
import {ReviewDoorElevations, ReviewDoorElevationTitle} from "../../quote/openings/ReviewDoorElevations";
import {ReviewDrwElevations} from "./ReviewDrwElevations";
import {Checkbox2Col} from "../ShopTableCol";
import {getAll} from "../../../logistics/routes/useGetAll";
import {DoorElevationSelector} from "../../quote/openings/DoorElevationSelector";
import {ProjectPageTitle} from "../ProjectPageTitle";
import {
    DoorElevationCell,
    DoorElevationColumnHeader,
    DoorElevationFilter,
    renderDoorElevationStr
} from "./DoorElevationHelpers";
import {WallTypeHeader} from "../../quote/openings/WallTypeHeader";
import {ScreenElevationHeader} from "../../quote/openings/ScreenElevationHeader";
import {ext} from "../../../../api/Files";
import {SubmittalHistory} from "../SubmittalHistory";
import {OpeningTimeline} from "./OpeningTimeline";
import {SubmittalsMenu} from "./SubmittalsMenu";
import {SubmittalMaker} from "./SubmittalMaker";
import {OpeningBulkActions} from "./OpeningBulkActions";
import {CheckboxProvider} from "../Checkbox";
import {ReviewFrameProfiles, ReviewTitle} from "../../quote/openings/ReviewFrameProfiles";
import {ReviewAnchors} from "../../quote/openings/ReviewAnchors";
import {ddlDoorSeriesFilter, DropDownContext, useDropdownData} from "../../settings/DropDowns";
import {WoodDetails} from "./WoodDetails";
import {ReviewDoorCore} from "../../quote/openings/ReviewDoorCore";
import {ReviewDoorSeam} from "../../quote/openings/ReviewDoorSeam";
import { LogiCtrlOpeningCell } from "./logictrl/OpeningCell";
import {
    applyDoorSeriesByOthers,
    applyFrameSeriesByOthers,
    copyDoorSeries,
    copyFrameSeries,
    DoorByOthersCell,
    DoorSeriesHeader,
    FrameByOthersCell,
    FrameSeriesHeader,
    pasteDoorSeries,
    pasteFrameSeries
} from "./ByOthers";
import {PickScreenElevation} from "./PickScreenElevation";
import {clearScreenSlot, parseScreenSlotPayload, screenSlotLabel, screenSlotPayload} from "./screenSlot";
import {PickDoorElevation} from "./PickDoorElevation";
import {PickHardwareElevation} from "./PickHardwareElevation";
import {ElevationSidebar} from "./elevationSidebar/ElevationSidebar";
import {ElevationCellFocusReporter, elevationColumnNames, ElevationSidebarProvider, UnlessElevationSidebarOpen} from "./elevationSidebar/ElevationSidebarContext";
import {PhaseCol} from "./PhaseCol";

const wordMap = {
    "released":"Released",
    "not-released":"Pending",
    "ordered":"Ordered",
    "in-warehouse":"In Warehouse",
    "in-truck":"In Truck",
    "delivered":"Delivered",
    "keying-complete": "Keying Complete",
    "returned": "Returned",

    "return-waiting-for-route": "Return: Waiting for Route",

    "po-draft": "PO Draft",
    "ready-for-pickup": "Ready for Pickup",
    "back-order": "Back Order",
    "scheduled-for-delivery": "Scheduled for Delivery",
    "not-active": "-",

    "pending-receiving": "Pending Receiving",

    "waiting-for-truck": "Waiting for Truck",
    "ready-to-deliver": "Ready to Deliver",
    "to-pick": "To Pick",
}

export function statusWords(key: string): string {
    // @ts-ignore
    return wordMap[key] || "unknown (" + key + ")"
}

export const statusMap: {
    [k: string]: {
        display: string;
        color: string;
    }
} = {
    "not-released": {
        display: wordMap["not-released"],
        color: grey["200"],
    },
    "released": {
        display: wordMap["released"],
        color: blue["100"],
    },
    "po-draft": {
        display: wordMap["po-draft"],
        color: cyan["200"],
    },
    "to-pick": {
        display: wordMap["to-pick"],
        color: cyan["200"],
    },
    "ordered": {
        display: wordMap["ordered"],
        color: purple["200"],
    },
    "ready-to-deliver": {
        display: wordMap["ready-to-deliver"],
        color: deepOrange["200"],
    },
    "ready-for-pickup": {
        display: wordMap["ready-for-pickup"],
        color: deepOrange["200"],
    },
    "pending-receiving": {
        display: wordMap["pending-receiving"],
        color: deepOrange["200"],
    },
    "returned": {
        display: wordMap["returned"],
        color: green["200"],
    },
    "back-order": {
        display: wordMap["back-order"],
        color: red["200"],
    },
    "waiting-for-truck": {
        display: wordMap["waiting-for-truck"],
        color: orange["200"],
    },
    "return-waiting-for-route": {
        display: wordMap["return-waiting-for-route"],
        color: orange["200"],
    },
    "in-warehouse": {
        display: wordMap["in-warehouse"],
        color: orange["200"],
    },
    "scheduled-for-delivery": {
        display: wordMap["scheduled-for-delivery"],
        color: lime["200"],
    },
    "in-truck": {
        display: wordMap["in-truck"],
        color: indigo["200"],
    },
    "delivered": {
        display: wordMap["delivered"],
        color: green["200"],
    },
    "keying-complete": {
        display: wordMap["keying-complete"],
        color: green["200"],
    },
    "not-active": {
        display: wordMap["not-active"],
        color: grey["100"],
    }
}

export function StatusCol<T>(name: string, key: keyof T) {
    return GenericStatusCol(name, key, statusMap);
}

export function openingsTableName(project: number, tab = "all") {
    return projectTablePrefName("project.openings." + tab, project)
}

export let currentTab = "";

export function Openings() {
    const [tab, setTab, dt] = useTabQueryParam({page: "shopdrawing.openings", urlKey: "tab", fallback: "doors", allowed: ["frames", "doors", "all"]});
    const [onlyConflicts] = useQueryParam("conflicts", "");
    const [showSubmittalHistory, setShowSubmittalHistory] = useState(false);
    const [showTimeline, setShowTimeline] = useState(false);
    const [showSuppliers, setShowSuppliers] = useState(false);

    const previewChangeset = useContext(ChangePreviewContext);

    const u = useUser();
    if(!u) return null;

    if(tab === "review-wall-type") {
        return (
            <ShopContainer name={<ReviewWallTypeTitle onDone={() => {
                setTab("frames")
            }} />}>
                <ProjectPageTitle title="Wall Types" />
                <ReviewWallTypes />
            </ShopContainer>
        );
    }

    if(tab === "review-screen-elevation") {
        return (
            <ShopContainer name={<ReviewScreenElevationTitle onDone={() => {
                setTab("frames")
            }} />}>
                <ProjectPageTitle title="Screen Elevations" />
                <ReviewScreenElevations />
            </ShopContainer>
        );
    }

    if(tab === "review-door-elevation") {
        return (
            <ShopContainer name={<ReviewDoorElevationTitle onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Door Elevations" />
                <ReviewDoorElevations />
            </ShopContainer>
        );
    }

    if(tab === "review-drw-screen-elevation") {
        return (
            <ShopContainer name={<ReviewTitle name="Review Screen Elevations" onDone={() => {
                setTab("frames")
            }} />}>
                <ProjectPageTitle title="Screen Elevations" />
                <ReviewDrwElevations kind="screen" />
            </ShopContainer>
        );
    }

    if(tab === "review-drw-door-elevation") {
        return (
            <ShopContainer name={<ReviewTitle name="Review Door Elevations" onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Door Elevations" />
                <ReviewDrwElevations kind="door" />
            </ShopContainer>
        );
    }

    if(tab === "review-drw-hardware-elevation") {
        return (
            <ShopContainer name={<ReviewTitle name="Review Hardware Elevations" onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Hardware Elevations" />
                <ReviewDrwElevations kind="hardware" />
            </ShopContainer>
        );
    }

    if(tab === "review-frame-profiles" ){
        return (
            <ShopContainer name={<ReviewTitle name="Review Frame Profiles" onDone={() => {
                setTab("frames")
            }} />}>
                <ProjectPageTitle title="Frame Profiles" />
                <ReviewFrameProfiles />
            </ShopContainer>
        );
    }

    if(tab === "review-anchors" ){
        return (
            <ShopContainer name={<ReviewTitle name="Review Anchors" onDone={() => {
                setTab("frames")
            }} />}>
                <ProjectPageTitle title="Anchors" />
                <ReviewAnchors />
            </ShopContainer>
        );
    }

    if(tab === "wood-details" ){
        return (
            <ShopContainer name={<ReviewTitle name="Wood Details" onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Wood Details" />
                <WoodDetails />
            </ShopContainer>
        );
    }


    if(tab === "review-door-core") {
        return (
            <ShopContainer name={<ReviewTitle name="Review Door Core" onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Door Core" />
                <ReviewDoorCore />
            </ShopContainer>
        );
    }

    if(tab === "review-door-seam") {
        return (
            <ShopContainer name={<ReviewTitle name="Review Door Seam" onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Door Seam" />
                <ReviewDoorSeam />
            </ShopContainer>
        );
    }

    return <SupplierProvider><ShopContainer name={<OpeningSwitcher />}
                          actions={<>
                              <SubmittalMaker creator={MakeSubmittal} />
                              <SubmittalsMenu />
                              <Grid item>
                                  <MenuButton
                                      renderButton={p => <SmallGreyButton endIcon={<ArrowDropDownIcon />} {...p} />}
                                      options={[{
                                          name: "Submittal History",
                                          onClick: () => setShowSubmittalHistory(true),
                                      }, {
                                          name: "View Timeline",
                                          onClick: () => setShowTimeline(true),
                                      }]}>Actions</MenuButton>
                              </Grid>
                              {showSubmittalHistory && <SubmittalHistory onClose={() => setShowSubmittalHistory(false)} />}
                              {showTimeline && <OpeningTimeline tab={tab} onClose={() => setShowTimeline(false)} />}
                            </>}
                          overrideRightActions={<div style={{
                              display: "flex",
                              alignItems: "flex-end",
                          }}>
                              {showSuppliers && <ManageProjectSuppliers onDone={() => setShowSuppliers(false)} />}
                              <div style={{
                                  marginTop: 4
                              }}>
                                  <HeaderActionButton
                                      label="Suppliers"
                                      icon={<StorefrontIcon fontSize="inherit" />}
                                      badgeContent={null}
                                      onClick={() => setShowSuppliers(true)}
                                  />
                              </div>
                              <ProjectActions />
            </div>}
    >
        <ProjectPageTitle title="Openings" />
        <ProjectPropertiesProvider>
            <ElevationSidebarProvider>
            <div style={{
                flex: 1, display: "flex",
                flexDirection: "row",
                overflow: "hidden",
            }}>
            <div style={{
                flex: 1, minWidth: 0, display: "flex",
                flexDirection: "column",
                overflow: "auto"
            }}>
                <TabWrapper>
                    <Tabs value={tab} onChange={(e, value) => {
                        setTab(value)
                    }}>
                        <Tab label="Frames" value="frames" {...dt.tabProps("frames")} />
                        <Tab label="Doors" value="doors" {...dt.tabProps("doors")} />
                        <Tab label="All" value="all" {...dt.tabProps("all")} />
                    </Tabs>
                    {dt.controls}
                </TabWrapper>

                <BreakHardwareLinkProvider>
                    <ConfirmWallTypeUpdateProvider>
                        <ConfirmSharedIdentityProvider>
                            <ConfirmAdoptIdentityProvider>
                                <OpeningTable tab={tab} onTabChange={setTab} onlyConflicts={onlyConflicts === "true"} />
                            </ConfirmAdoptIdentityProvider>
                        </ConfirmSharedIdentityProvider>
                    </ConfirmWallTypeUpdateProvider>
                </BreakHardwareLinkProvider>
            </div>
            <ElevationSidebar />
            </div>
            {!previewChangeset.enabled && <UnlessElevationSidebarOpen><ProjectProperties /></UnlessElevationSidebarOpen>}
            </ElevationSidebarProvider>
        </ProjectPropertiesProvider>
    </ShopContainer></SupplierProvider>
}

// --- drw elevation copy/paste + clear ---
// Linking/unlinking an opening's drw elevation is a server operation, not a field on the opening
// upsert: door assigns a shared FK, screen also adopts identity, hardware clones the source (see
// the drw adopt/unlink handlers / PickDoorElevation). So copy encodes the source elevation id and
// backspace signals a clear; paste/clear stash an intent on the row, and onChange/onBulkChange
// dispatches the matching adopt/unlink endpoint.
type DrwAdoptKind = "door" | "screen" | "hardware";

function drwAdoptField(kind: DrwAdoptKind): string {
    return kind === "door" ? "__adoptDoorElevation"
        : kind === "screen" ? "__adoptScreenElevation"
        : "__adoptHardwareElevation";
}

function drwUnlinkField(kind: DrwAdoptKind): string {
    return kind === "door" ? "__unlinkDoorElevation"
        : kind === "screen" ? "__unlinkScreenElevation"
        : "__unlinkHardwareElevation";
}

function drwElevationField(kind: DrwAdoptKind): keyof Opening {
    return kind === "door" ? "drwDoorElevation"
        : kind === "screen" ? "drwScreenElevation"
        : "drwHardwareElevation";
}

// clear (backspace/delete): when the cell holds a drw elevation of this kind, stash an unlink
// intent for onChange/onBulkChange to dispatch and blank the fk optimistically. Returns true when
// it was a drw cell (so the caller skips its legacy clearing).
function clearDrwElevation(kind: DrwAdoptKind, data: any): boolean {
    if(!data[drwElevationField(kind)]) return false;
    data[drwUnlinkField(kind)] = true;
    data[drwElevationField(kind)] = undefined;
    return true;
}

// the clipboard value for a drw elevation cell: the source elevation id tagged by kind, or ""
// when the cell has no drw elevation.
function drwAdoptPayload(kind: DrwAdoptKind, id: number | null | undefined): string {
    return id ? JSON.stringify({__drwAdopt: kind, id}) : "";
}

function parseDrwAdopt(value: string): {kind: DrwAdoptKind; id: number} | null {
    if(!value) return null;
    try {
        const o = JSON.parse(value);
        if((o?.__drwAdopt === "door" || o?.__drwAdopt === "screen" || o?.__drwAdopt === "hardware") && typeof o.id === "number") {
            return {kind: o.__drwAdopt, id: o.id};
        }
    } catch {
        // not a drw payload (e.g. legacy value or plain text)
    }
    return null;
}

// paste: when value is a drw payload, adopt it (if the kind matches this column) and report
// handled so the caller doesn't also write it as a plain value. Returns false for a non-payload
// value (the caller pastes it normally).
function applyDrwAdopt(kind: DrwAdoptKind, data: any, value: string): boolean {
    const a = parseDrwAdopt(value);
    if(!a) return false;
    if(a.kind === kind) data[drwAdoptField(kind)] = a.id;
    return true;
}

// an adopt (paste) or unlink (clear) intent was stashed on the row — onChange/onBulkChange should
// dispatch the drw endpoint(s) instead of a plain opening upsert.
function hasDrwElevationOp(row: any): boolean {
    return !!(row.__adoptDoorElevation || row.__adoptScreenElevation || row.__adoptScreenSlot || row.__adoptHardwareElevation
        || row.__unlinkDoorElevation || row.__unlinkScreenElevation || row.__unlinkHardwareElevation);
}

// the grey text of an elevation cell with no link: "Default" when the opening renders a default.
function defaultCellText(data: Opening, kind: DrwKind): string {
    return isDrwDefault(data, kind) ? "Default" : "";
}

// the filter/sort string for the Screen Elevation cell.
function screenCellString(data: Opening): string {
    if(data.drwScreenPrimaryOpening) return screenSlotLabel(data);
    return data.drwScreenElevation ? (data.drwScreenElevationName || "") : (data.screenElevation || "");
}

// the filter/sort string for the merged HW Elevation cell: the elevation name (with a custom flag)
// when linked, else the Standard/Custom prep-locations status it absorbed from the old column.
function hwElevationCellString(data: Opening): string {
    if(isWindow(data)) return ""; // windows have no hardware
    if(data.drwHardwareElevation) {
        return (data.drwHardwareElevationName || "") + (data.prepIsCustom ? " (custom)" : "");
    }

    return data.prepIsCustom ? "Custom" : "Standard";
}

// the HW Elevation cell. With an elevation: the name (+ "(custom)" when the opening has custom prep
// locations) and the open-in-tool arrow. Without one: the "new" (draw) icon and the Standard/Custom
// prep status — clicking the status opens the Customize Hardware Locations dialog (the old "Prep
// Locations" control). The cell's own click still opens the pick/draw elevation editor.
function HwElevationCell(props: {data: Opening; project: number}) {
    const {data, project} = props;
    const editCtx = useContext(EditContext);
    const nav = useNavigate();
    const [prepOpen, setPrepOpen] = useState(false);

    if(isWindow(data)) return null; // windows have no hardware / prep locations

    const hasElevation = !!data.drwHardwareElevation;
    const isCustom = !!data.prepIsCustom;
    const url = hardwareElevationToolUrl({project, opening: data.id});

    // opens the elevation tool on the current page. stopPropagation keeps a click on the icon from
    // also opening the cell editor; the href is kept so a ctrl/cmd-click still opens a new tab.
    const iconLink = (icon: any, title: string) => (
        <Tooltip title={title}>
            <a href={url} onClick={e => openElevation(e, nav, url)}
               style={{color: grey["500"], display: "inline-flex", marginLeft: 4}}>
                {icon}
            </a>
        </Tooltip>
    );

    return (
        <div style={{display: "flex", position: "relative", alignItems: "center"}}>
            {hasElevation ? (
                <div style={{flex: 1}}>
                    {data.drwHardwareElevationName || ""}
                    {isCustom && <span style={{color: grey["500"]}}> (custom)</span>}
                </div>
            ) : (
                <div style={{flex: 1}}>
                    {isDrwDefault(data, "hardware") && <span style={{color: grey["500"]}}>Default · </span>}
                    <span
                        style={{fontStyle: "italic", textDecoration: "underline", cursor: "pointer"}}
                        onClick={e => { e.stopPropagation(); setPrepOpen(true); }}
                    >{isCustom ? "Custom" : "Standard"}</span>
                </div>
            )}
            {hasElevation
                ? iconLink(<OpenInNew style={{fontSize: "0.9rem"}}/>, "Open in elevation tool")
                : iconLink(<NoteAddOutlined style={{fontSize: "0.9rem"}}/>, "Draw new elevation")}

            {prepOpen && (
                <PrepLocations
                    value={data}
                    onDone={() => { editCtx.reload(true); setPrepOpen(false); }}
                    onCancel={() => setPrepOpen(false)}
                />
            )}
        </div>
    );
}

function OpeningTable(props: {
    tab: string;
    onTabChange(value: string): void;
    onlyConflicts?: boolean;
}) {
    const tab = props.tab;
    const project = useProjectId();
    const nav = useNavigate();
    const sys = useProjectUnitSystem();
    const [key] = useState("-")

    // dispatch drw elevation adopt (paste) / unlink (clear) intents stashed on a row (see the drw
    // helpers). Returns true when at least one ran, so the caller reloads instead of upserting.
    const applyDrwElevationOps = async (row: any): Promise<boolean> => {
        let did = false;
        if(row.__adoptDoorElevation) {
            await api.elevationTool.adoptDoor({project, opening: row.id, door: row.__adoptDoorElevation});
            did = true;
        }
        if(row.__adoptScreenElevation) {
            // adopting a screen overwrites opening properties (handing etc.) to match the
            // elevation; when the server reports the diff instead of saving, prompt (update
            // the opening, or link a private copy when offered), then re-send with the
            // resolution. On cancel nothing was saved — the reload reverts the cell.
            const res = await api.elevationTool.adoptScreen({project, opening: row.id, screen: row.__adoptScreenElevation});
            if(res.identityChanges?.length) {
                const resolution = await adoptIdentityConfirm.confirm(res.identityChanges, !!res.canCopy);
                if(resolution) {
                    await api.elevationTool.adoptScreen({project, opening: row.id, screen: row.__adoptScreenElevation, confirm: resolution === "update", copy: resolution === "copy"});
                }
            }
            did = true;
        }
        if(row.__adoptScreenSlot) {
            await api.elevationTool.adoptScreenSlot({project, opening: row.id, ...row.__adoptScreenSlot});
            did = true;
        }
        if(row.__adoptHardwareElevation) {
            await adoptHardwareElevation(confirm.confirm, {project, opening: row.id, hardware: row.__adoptHardwareElevation});
            did = true;
        }
        if(row.__unlinkDoorElevation) {
            await api.elevationTool.unlinkDoor({project, opening: row.id});
            did = true;
        }
        if(row.__unlinkScreenElevation) {
            await api.elevationTool.unlinkScreen({project, opening: row.id});
            did = true;
        }
        if(row.__unlinkHardwareElevation) {
            await api.elevationTool.unlinkHardware({project, opening: row.id});
            did = true;
        }
        return did;
    };

    const previewChangeset = useContext(ChangePreviewContext);
    const hwContext = useContext(BreakHardwareLinkContext);
    const wallTypeConfirm = useConfirmWallTypeUpdate();
    const sharedIdentityConfirm = useConfirmSharedIdentity();
    const adoptIdentityConfirm = useConfirmAdoptIdentity();
    const confirm = useConfirm();
    const {locked} = useContext(ManagerLockContext)

    const showDoor = (tab === "doors" || tab === "all");
    const showFrame = (tab === "frames" || tab === "all");
    const tableName = openingsTableName(project, tab);

    currentTab = tab;
    const {openingAutoFill} = useContext(ProjectPropertiesContext)

    const ddl = useContext(DropDownContext);
    const frameProfileOptions = useDropdownData(ddl.frameProfiles);
    const doorMaterialOptions = useDropdownData(ddl.doorMaterial);
    const doorFinishOptions = useDropdownData(ddl.doorMaterialWoodFinish);
    const doorCoreOptions = useDropdownData(ddl.doorCores);
    const doorSeamOptions = useDropdownData(ddl.doorSeam);

    if(ddl.loading) return <CircularProgress />
    if(!sys) return <CircularProgress />

    const actionsColumn: Column<Opening> = {
        name: actionsColName,
        noCsv: true,
        render: o => <RowActions row={o} />,
        renderName: () => <OpeningBulkActions />,
        width: 100,
    };

    return (
        <>
            <CheckboxProvider>
                <WithChangesetMeta>
                    {changeset => <Table<Opening>
                        key={key+ tab}
                        locked={locked}
                        name={tableName}
                        globalPrefsName={openingsTableName(0, tab)}
                        onDrag={async (input) => {
                            await api.openings.reOrder({
                                project: project,
                                idOrder: input.idOrder,
                            })

                            return {
                                sortByCol: null
                            }
                        }}
                        cellCustomize={{
                            backgroundColor: (row: Opening, c: Column<Opening>) => {
                                if(!changeset.proposing) {
                                    return null;
                                }

                                // flag conflicting rows on the actions column even when the conflict
                                // comes from another change's merge rather than a local cell edit
                                if(c === actionsColumn && row.logictrl?.conflictsWithMain) {
                                    return deepOrange["100"];
                                }

                                let changed = false;

                                if("isChangedSinceBackup" in c && c.isChangedSinceBackup) {
                                    changed = c.isChangedSinceBackup(row)
                                } else if(c.editKey) {
                                    changed = !!row.backup && lookupNestedProp(row.backup, c.editKey) !== lookupNestedProp(row, c.editKey)
                                } else {
                                    changed = false;
                                }

                                if(changed) {
                                    if(row.logictrl?.conflictsWithMain) {
                                        return deepOrange["100"];
                                    }

                                    return "white"
                                }

                                return cellInActive;
                            },
                            onFocusLocked: (row: Opening, c: Column<Opening>) => <ElevationCellFocusReporter row={row} column={c} />,
                            onFocus: (row: Opening, c: Column<Opening>, anchor: any) => {
                                const reporter = <ElevationCellFocusReporter row={row} column={c} />;
                                if(!changeset.proposing) {
                                    return reporter;
                                }

                                let changed = false;

                                if("isChangedSinceBackup" in c && c.isChangedSinceBackup) {
                                    changed = c.isChangedSinceBackup(row)
                                } else if(c.editKey) {
                                    changed = !!row.backup && lookupNestedProp(row.backup, c.editKey) !== lookupNestedProp(row, c.editKey)
                                } else {
                                    changed = false;
                                }

                                if(changed) {
                                    const value = row.backup as any;

                                    return (
                                        <>
                                            {reporter}
                                            <PreviousValuePopup
                                                anchor={anchor} width={c.width}
                                                value={c.render(value, c)}
                                                hasConflict={row.logictrl?.conflictsWithMain}
                                            />
                                        </>
                                    )
                                }

                                return reporter;
                            }
                        }}
                        columns={[actionsColumn,
                            SeqNumber("seqNumber", tableName, (ids) => api.openings.reSequence({
                                project: project,
                                idOrder: ids,
                            })),
                            RenderStringCol2<Opening>("Changes", () => "", (dt) => (
                                <div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}>
                                    {dt.logictrl && <LogiCtrlOpeningCell value={dt.logictrl} opening={dt.id} name={dt.name} />}
                                </div>
                            )),
                            StringCol("Opening", "name"),
                            NumberCol("Qty", "qty"),
                            StringCol("Floor", "floor"),
                            PhaseCol<Opening>(),
                            Checkbox2Col("Ext", "exterior"),
                            StringCol("Location", "locationOne"),
                            Select2Col<Opening>("To/From", "locationTransition", locationTransitions),
                            StringCol<Opening>("Location 2", "locationTwo"),
                            AdjustCol(Select2Col<Opening>("Type", "openingType", openingTypes), {
                                editable: {
                                    type: "select",
                                    options: () => openingTypes.map(o => ({
                                        display: o,
                                        value: o,
                                    })),
                                    onChangeBeforeSave: (row: Opening, value: string) => {
                                        row.nominalWidth = "";
                                        row.inactiveDoorWidth = "";
                                        row.handing = "";
                                    }
                                }
                            }),
                            NominalWidth<Opening>("Nominal Width", sys, "nominalWidth", "inactiveDoorWidth"),
                            DistanceCol("Nominal Height", sys, "nominalHeight"),
                            AdjustCol(StringCol("Hand", "handing"), {
                                editable: {
                                    type: "select",
                                    options: handingOptions,
                                    onChangeBeforeSave: (row: Opening, value: string) => {
                                        updateFrameProfileBasedOnHanding(row)
                                    }
                                },
                                disabled: isWindow as any,
                            }),
                            Select2Col<Opening>("Label", "label", labels),
                            showFrame && AdjustCol(Select2Col<Opening>("Frame Series", "frameSeries", frameSeries), {
                                renderName: () => <FrameSeriesHeader />,
                                render: (data: Opening) => (
                                    <div style={{display: "flex", position: "relative"}}>
                                        <div style={{flex: 1}}>{data.frameSeries}</div>
                                        <FrameByOthersCell data={data} />
                                    </div>
                                ),
                                width: 150,
                                editable: {
                                    type: "select",
                                    getValue: (o: Opening) => o.frameSeries,
                                    options: () => frameSeries.map(o => ({display: o, value: o})),
                                    onChangeBeforeSave: (row: Opening, value: string) => applyFrameSeriesByOthers(row, value),
                                    copy: copyFrameSeries,
                                    paste: pasteFrameSeries,
                                },
                            }),
                            showFrame && SelectCol<Opening>("Frame Material", "frameMaterial", frameMaterial),
                            showFrame && AdjustCol(SelectCol<Opening>("Frame Gauge", "frameGauge", frameGauge), {
                                alignRight: true,
                            }),
                            showFrame && {
                                name: elevationColumnNames.screen,
                                renderName: () => <ScreenElevationHeader />,
                                isChangedSinceBackup: (row: Opening) => {
                                    if(row.drwScreenElevationChanged) return true;
                                    if(!row.backup) return false;
                                    return row.screenElevation !== row.backup.screenElevation
                                        || row.screenElevationFile !== row.backup.screenElevationFile
                                        || row.drwScreenElevation !== row.backup.drwScreenElevation
                                        || row.drwScreenPrimaryOpening !== row.backup.drwScreenPrimaryOpening
                                        || row.drwScreenSlot !== row.backup.drwScreenSlot
                                },
                                // legacy openings (file-based screen elevation, no drw link) keep the
                                // popup editor. Everything else — blank or already on a drw elevation —
                                // gets the autocomplete to pick an existing drw screen elevation (adopts
                                // its identity) on cell click (the icon still opens the tool; see render).
                                editableFunc: (row: Opening) => {
                                    const isNew = !!row.drwScreenElevation || !!row.drwScreenPrimaryOpening;
                                    const isLegacy = !isNew && !!row.screenElevation;

                                    if(!isLegacy) {
                                        return {
                                            editable: {
                                                type: "custom",
                                                // copy the linked screen id, or the frame slot of a secondary opening;
                                                // paste adopts it server-side (see applyDrwElevationOps).
                                                copy: (data) => data.drwScreenPrimaryOpening ? screenSlotPayload(data) : drwAdoptPayload("screen", data.drwScreenElevation),
                                                paste: (data: any, value) => {
                                                    if(value === "") {
                                                        clearScreenSlot(data);
                                                        clearDrwElevation("screen", data);
                                                        return;
                                                    }

                                                    const slot = parseScreenSlotPayload(value);
                                                    if(slot) { data.__adoptScreenSlot = slot; return; }
                                                    applyDrwAdopt("screen", data, value);
                                                },
                                                render: (props) => <PickScreenElevation {...props} />,
                                            },
                                        };
                                    }

                                    return {
                                        editable: {
                                            type: "custom",
                                            copy: data => data.screenElevation?.toString() || "",
                                            paste: (data: any, value) => {
                                                // pasting a copied drw screen elevation or frame slot onto a legacy cell adopts it.
                                                const slot = parseScreenSlotPayload(value);
                                                if(slot) { data.__adoptScreenSlot = slot; return; }
                                                if(applyDrwAdopt("screen", data, value)) return;
                                                data.screenElevation = value;
                                                data.screenElevationFile = undefined;
                                            },
                                            render: (props) => {
                                                return <ScreenElevationPopup {...props} />
                                            },
                                            fileDropAccept: ["application/pdf", "image/*"],
                                            fileDropAction: async (files, info) => {
                                                const fileObj = await api.files.upload({
                                                    file: files[0],
                                                    // use guid naming to prevent collisions
                                                    name: window.crypto.randomUUID() + ext(files[0].name),
                                                    convert2pdf: true,
                                                });

                                                info.update(Object.assign({}, info.row, {
                                                    screenElevationFile: fileObj.id,
                                                }));
                                            },
                                        },
                                    };
                                },
                                editObj: (dst, src, value: string) => {
                                    // backspace/delete on the cell clears everything: unlink a drw
                                    // screen elevation (via clearDrwElevation) and clear the legacy value.
                                    if(!value) {
                                        clearScreenSlot(dst);
                                        clearDrwElevation("screen", dst);
                                        dst.drwScreenElevationName = undefined;
                                    }

                                    dst.screenElevation = value;
                                    dst.screenElevationFile = undefined;
                                },
                                render: (data, col) => {
                                    // a secondary opening fills a door slot on its primary's frame.
                                    if(data.drwScreenPrimaryOpening) {
                                        return <div><span style={{color: grey["500"]}}>Frame of </span>{screenSlotLabel(data)}</div>;
                                    }

                                    const isNew = !!data.drwScreenElevation;
                                    const isLegacy = !isNew && !!data.screenElevation;

                                    const url = `/project/${project}/shop-drawing/elevation-tool?opening=${data.id}&workspace=screen`;

                                    // opens the elevation tool on the current page. stopPropagation keeps a
                                    // click on the icon from also opening the legacy edit popup; the href is
                                    // kept so a ctrl/cmd-click still opens a new tab.
                                    const iconLink = (icon: any, title: string) => (
                                        <Tooltip title={title}>
                                            <a href={url} onClick={e => openElevation(e, nav, url)}
                                               style={{color: grey["500"], display: "inline-flex", marginLeft: 4}}>
                                                {icon}
                                            </a>
                                        </Tooltip>
                                    );

                                    // legacy: name is edited via the popup on click; the convert icon
                                    // jumps into the new elevation tool.
                                    if(isLegacy) {
                                        return (
                                            <div style={{display: "flex", position: "relative", alignItems: "center"}}>
                                                <div style={{flex: 1}}>{data.screenElevation || ""}</div>
                                                {iconLink(<ChangeCircleOutlined style={{fontSize: "0.9rem"}}/>, "Convert to elevation tool")}
                                            </div>
                                        )
                                    }

                                    // drw or blank: clicking the cell opens the pick-an-existing-screen
                                    // autocomplete (see editableFunc). The icon opens the tool in a new
                                    // tab — to view the linked drawing, or draw one from scratch.
                                    return (
                                        <div style={{display: "flex", position: "relative", alignItems: "center"}}>
                                            <div style={{flex: 1, color: isNew ? "inherit" : grey["500"]}}>{isNew ? (data.drwScreenElevationName || "") : defaultCellText(data, "screen")}</div>
                                            {isNew
                                                ? iconLink(<OpenInNew style={{fontSize: "0.9rem"}}/>, "Open in elevation tool")
                                                : iconLink(<NoteAddOutlined style={{fontSize: "0.9rem"}}/>, "Draw new elevation")}
                                        </div>
                                    )
                                },
                                headerMenuItems: () => {
                                    return [{
                                        name: "Review Screen Elevations",
                                        onClick: () => {
                                            props.onTabChange("review-drw-screen-elevation")
                                        }
                                    }, {
                                        name: "Review Screen Elevations (File-based)",
                                        onClick: () => {
                                            props.onTabChange("review-screen-elevation")
                                        }
                                    }]
                                },
                                filter: (data, search) => {
                                    return screenCellString(data).toLowerCase().startsWith(search.toLowerCase())
                                },
                                sort: (a, b) => {
                                    return sortStringInner(screenCellString(a), screenCellString(b))
                                }
                            },
                            showFrame && AdjustCol(SelectCol<Opening>("Frame Profile", "frameProfile", makeSelectWrapper(frameProfileOptions)), {
                                headerMenuItems: () => {
                                    return [{
                                        name: "Review Frame Profiles",
                                        onClick: () => {
                                            props.onTabChange("review-frame-profiles")
                                        }
                                    }]
                                },
                            }),
                            showFrame && {
                                name: "Wall Type",
                                renderName: () => <WallTypeHeader />,
                                isChangedSinceBackup: (row: Opening) => {
                                    if(!row.backup) return false;
                                    return row.drawingWallLabel !== row.backup.drawingWallLabel || row.drawingWallLabelFile !== row.backup.drawingWallLabelFile
                                },
                                editable: {
                                    type: "custom",
                                    copy: data => data.drawingWallLabel?.toString() || "",
                                    paste: (data, value) => {
                                        data.drawingWallLabel = value;
                                    },
                                    render: (props) => {
                                        if(!props.row.drawingWallLabel) {
                                            return (
                                                <TextEditCell keyName="drawingWallLabel" {...props} />
                                            )
                                        }

                                        return <DrawingWallLabelPopup {...props} />
                                    },
                                    fileDropAccept: ["application/pdf", "image/*"],
                                    fileDropAction: async (files, info) => {
                                        const fileObj = await api.files.upload({
                                            file: files[0],
                                            // use guid naming to prevent collisions
                                            name: window.crypto.randomUUID() + ext(files[0].name),
                                            convert2pdf: true,
                                        });

                                        info.update(Object.assign({}, info.row, {
                                            drawingWallLabelFile: fileObj.id,
                                        }));
                                    },
                                },
                                editObj: (dst, src, value: string) => {
                                    dst.drawingWallLabel = value;
                                    dst.drawingWallLabelFile = undefined;
                                },
                                render: (data, col) => {
                                    return data.drawingWallLabel || "";
                                },
                                width: 100,
                                headerMenuItems: () => {
                                    return [{
                                        name: "Review Wall Types",
                                        onClick: () => {
                                            props.onTabChange("review-wall-type")
                                        }
                                    }]
                                },
                                filter: (data, search) => {
                                    return (data.drawingWallLabel || "").toLowerCase().startsWith(search.toLowerCase())
                                },
                                sort: (a, b) => {
                                    return sortStringInner(a.drawingWallLabel || "", b.drawingWallLabel || "")
                                }
                            },
                            showFrame && JambDepthCol("Jamb Depth", "jambDepth"),
                            showFrame && SelectCol<Opening>("Frame Construction", "frameConstruction", frameConstruction),
                            showFrame && AnchorCol<Opening>({
                                onTabChange: v => props.onTabChange(v),
                                elevationUrl: data => `/project/${project}/shop-drawing/elevation-tool?opening=${data.id}&workspace=screen`,
                            }),
                            showDoor && AdjustCol(Select2Col<Opening>("Door Series", "doorSeries", doorSeries), {
                                disabled: isWindow as any,
                                renderName: () => <DoorSeriesHeader />,
                                render: (data: Opening) => (
                                    <div style={{display: "flex", position: "relative"}}>
                                        <div style={{flex: 1}}>{data.doorSeries}</div>
                                        <DoorByOthersCell data={data} />
                                    </div>
                                ),
                                width: 150,
                                editable: {
                                    type: "select",
                                    getValue: (o: Opening) => o.doorSeries,
                                    options: () => doorSeries.map(o => ({display: o, value: o})),
                                    onChangeBeforeSave: (row: Opening, value: string) => applyDoorSeriesByOthers(row, value),
                                    copy: copyDoorSeries,
                                    paste: pasteDoorSeries,
                                },
                            }),
                            showDoor && AdjustCol(SelectCol<Opening>("Door Material", "doorMaterial", makeSelectWrapper(doorMaterialOptions, ddlDoorSeriesFilter)), {
                                disabled: isWindow as any,
                                headerMenuItems: () => {
                                    return [{
                                        name: "Review Wood Materials",
                                        onClick: () => {
                                            props.onTabChange("wood-details")
                                        }
                                    }]
                                },
                            }),
                            showDoor && AdjustCol(SelectCol<Opening>("Door Finish", "doorFinish", makeSelectWrapper(doorFinishOptions, ddlDoorSeriesFilter), {
                                freeSolo: true
                            }), {
                                disabled: isWindow as any,
                            }),
                            showDoor && AdjustCol(SelectCol<Opening>("Door Gauge", "doorGauge", doorGauge), {
                                alignRight: true,
                            }),
                            showDoor && AdjustCol(SelectCol<Opening>("Door Thickness", "doorThickness", makeSelectWrapper(doorThicknesses(sys).map(v => ({display: v, value: v}))), {
                                freeSolo: true,
                                parseValue: (raw, str) => cleanDoorThickness(sys, str),
                                validate: (str) => validateDoorThickness(sys, str),
                            }), {
                                disabled: isWindow as any,
                            }),
                            showDoor && AdjustCol<Opening>({
                                name: elevationColumnNames.door,
                                width: 200,
                                renderName:() => {
                                    return <DoorElevationColumnHeader />
                                },
                                renderFilter: (props) => {
                                    return <DoorElevationFilter {...props} />
                                },
                                // legacy openings (file-based door elevation, no drw link) keep the
                                // popup editor. Everything else — blank or already on a drw elevation —
                                // gets the autocomplete to pick an existing drw door elevation on cell
                                // click (the icon still opens the tool; see render).
                                editableFunc: (row: Opening) => {
                                    const isNew = !!row.drwDoorElevation;
                                    const isLegacy = !isNew && (!!row.doorElevation || !!row.doorElevationFile);

                                    if(!isLegacy) {
                                        return {
                                            editable: {
                                                type: "custom",
                                                // copy the linked door id; paste adopts it server-side (see applyDrwElevationOps).
                                                copy: (data) => drwAdoptPayload("door", data.drwDoorElevation),
                                                paste: (data, value) => {
                                                    if(value === "") { clearDrwElevation("door", data); return; }
                                                    applyDrwAdopt("door", data, value);
                                                },
                                                render: (props) => <PickDoorElevation {...props} />,
                                            },
                                        };
                                    }

                                    return {
                                        editable: {
                                            type: "custom",
                                            copy: data => JSON.stringify({
                                                doorElevation: data.doorElevation,
                                                inactiveDoorElevation: data.inactiveDoorElevation
                                            }),
                                            paste: (data, value) => {
                                                // pasting a copied drw door elevation onto a legacy cell adopts it.
                                                if(applyDrwAdopt("door", data, value)) return;
                                                if(!value) return; // blank source — nothing to paste
                                                const obj = JSON.parse(value) as {doorElevation: string, inactiveDoorElevation: string}
                                                data.doorElevation = obj.doorElevation
                                                data.doorElevationFile = undefined;
                                                data.inactiveDoorElevation = obj.inactiveDoorElevation
                                                data.inactiveDoorElevationFile = undefined;
                                            },
                                            render: (props) => {
                                                return <DoorElevationSelector {...props} />
                                            },
                                            fileDropAccept: ["application/pdf", "image/*"],
                                            fileDropAction: async (files, info) => {
                                                const fileObj = await api.files.upload({
                                                    file: files[0],
                                                    // use guid naming to prevent collisions
                                                    name: window.crypto.randomUUID() + ext(files[0].name),
                                                    convert2pdf: true,
                                                });

                                                info.update(Object.assign({}, info.row, {
                                                    doorElevationFile: fileObj.id,
                                                    inactiveDoorElevationFile: undefined,
                                                }));
                                            },
                                        },
                                    };
                                },
                                editObj: (dst, src, value: string) => {
                                    if(value === "") {
                                        clearDrwElevation("door", dst); // unlink a drw door elevation, if linked
                                        dst.doorElevation = ""
                                        dst.doorElevationFile = undefined;
                                        dst.inactiveDoorElevation = ""
                                        dst.inactiveDoorElevationFile = undefined;
                                    } else {
                                        throw new Error("unsupported action")
                                    }
                                },
                                // @ts-ignore
                                isChangedSinceBackup: (row: Opening) => {
                                    if(row.drwDoorElevationChanged) return true;
                                    if(!row.backup) return false;
                                    if(row.doorElevation !== row.backup?.doorElevation) return true
                                    if(row.doorElevationFile !== row.backup?.doorElevationFile) return true
                                    if(row.inactiveDoorElevation !== row.backup?.inactiveDoorElevation) return true;
                                    if(row.inactiveDoorElevationFile !== row.backup?.inactiveDoorElevationFile) return true;
                                    if(row.drwDoorElevation !== row.backup?.drwDoorElevation) return true;
                                    return false
                                },
                                render: (data, col) => {
                                    const isNew = !!data.drwDoorElevation;
                                    const isLegacy = !isNew && (!!data.doorElevation || !!data.doorElevationFile);

                                    const url = `/project/${project}/shop-drawing/elevation-tool?opening=${data.id}&workspace=door`;

                                    // opens the elevation tool on the current page. stopPropagation keeps a
                                    // click on the icon from also opening the legacy edit popup; the href is
                                    // kept so a ctrl/cmd-click still opens a new tab.
                                    const iconLink = (icon: any, title: string) => (
                                        <Tooltip title={title}>
                                            <a href={url} onClick={e => openElevation(e, nav, url)}
                                               style={{color: grey["500"], display: "inline-flex", marginLeft: 4}}>
                                                {icon}
                                            </a>
                                        </Tooltip>
                                    );

                                    // legacy: name is edited via the popup on click; the convert icon
                                    // jumps into the new elevation tool.
                                    if(isLegacy) {
                                        return (
                                            <div style={{display: "flex", position: "relative", alignItems: "center"}}>
                                                <div style={{flex: 1}}><DoorElevationCell data={data} /></div>
                                                {iconLink(<ChangeCircleOutlined style={{fontSize: "0.9rem"}}/>, "Convert to elevation tool")}
                                            </div>
                                        )
                                    }

                                    // drw or blank: clicking the cell opens the pick-an-existing-door
                                    // autocomplete (see editableFunc). The icon opens the tool in a new
                                    // tab — to view the linked drawing, or draw one from scratch.
                                    return (
                                        <div style={{display: "flex", position: "relative", alignItems: "center"}}>
                                            <div style={{flex: 1, position: "relative", color: isNew ? "inherit" : grey["500"]}}>
                                                {isNew ? (data.drwDoorElevationName || "") : defaultCellText(data, "door")}
                                                {isNew && <DrwDoorThermalCheckbox checked={!!data.drwDoorThermal} />}
                                            </div>
                                            {isNew
                                                ? iconLink(<OpenInNew style={{fontSize: "0.9rem"}}/>, "Open in elevation tool")
                                                : iconLink(<NoteAddOutlined style={{fontSize: "0.9rem"}}/>, "Draw new elevation")}
                                        </div>
                                    )
                                },
                                headerMenuItems: () => {
                                    return [{
                                        name: "Review Door Elevations",
                                        onClick: () => {
                                            props.onTabChange("review-drw-door-elevation")
                                        }
                                    }, {
                                        name: "Review Door Elevations (File-based)",
                                        onClick: () => {
                                            props.onTabChange("review-door-elevation")
                                        }
                                    }]
                                },
                                filter: (data, search) => {
                                    const name = data.drwDoorElevation ? (data.drwDoorElevationName || "") : renderDoorElevationStr(data, false);
                                    return name.toLowerCase().startsWith(search.toLowerCase())
                                },
                                sort: (a, b) => {
                                    const an = a.drwDoorElevation ? (a.drwDoorElevationName || "") : renderDoorElevationStr(a, false);
                                    const bn = b.drwDoorElevation ? (b.drwDoorElevationName || "") : renderDoorElevationStr(b, false);
                                    return sortStringInner(an, bn)
                                },
                            }, {
                                disabled: isWindow as any,
                            }),
                            showDoor && AdjustCol(SelectCol<Opening>("Door Core", "doorCore", makeSelectWrapper(doorCoreOptions, ddlDoorSeriesFilter)), {
                                disabled: isWindow as any,
                                headerMenuItems: () => {
                                    return [{
                                        name: "Review Door Cores",
                                        onClick: () => {
                                            props.onTabChange("review-door-core")
                                        }
                                    }]
                                },
                            }),
                            showDoor && AdjustCol(SelectCol<Opening>("Door Seam", "doorSeam", makeSelectWrapper(doorSeamOptions, ddlDoorSeriesFilter)), {
                                disabled: isWindow as any,
                                headerMenuItems: () => {
                                    return [{
                                        name: "Review Door Seams",
                                        onClick: () => {
                                            props.onTabChange("review-door-seam")
                                        }
                                    }]
                                },
                            }),
                            {
                                name: "Hardware Heading",
                                render: (data, col) => {
                                    return data.hardwareGroupName || "";
                                },
                                editKey: "hardwareGroupName",
                                isChangedSinceBackup: (row) => {
                                    if(row.backup) {
                                        return row.hardwareGroup !== row.backup.hardwareGroup
                                    }

                                    return false;
                                },
                                editable: {
                                    type: "custom",
                                    render: props => <EditHardwareGroup isQuote={false} {...props} />
                                },
                                filter: (data, search) => {
                                    return data.hardwareGroupName?.indexOf(search) === 0
                                },
                                disabled: isWindow as any,
                            },
                            {
                                name: "HW Shortcode",
                                width: 150,
                                render: (data) => {
                                    return data.hardwareGroupShortcodeName || ""
                                },
                                filter: (data, search) => {
                                    return data.hardwareGroupShortcodeName && data.hardwareGroupShortcodeName.toLowerCase().indexOf(search.toLowerCase()) !== -1
                                },
                                sort: (a, b) => {
                                    return sortStringInner(a.hardwareGroupShortcodeName || "", b.hardwareGroupShortcodeName || "")
                                },
                                editKey: "hardwareGroupShortcodeName",
                                editable: {
                                    type: "lookup",
                                    displayKey: "hardwareGroupShortcodeName",
                                    options: async (search: string) => {
                                        const list = await api.hardwareLibrary.getShortCodes({
                                            search,
                                            project,
                                            type: "hardware",
                                        });

                                        return list.map(v => ({
                                            display: v.value,
                                            value: v.value,
                                        }))
                                    },
                                },
                                disabled: isWindow as any,
                            },
                            AdjustCol<Opening>({
                                name: elevationColumnNames.hardware,
                                width: 200,
                                // absorbs the old "Prep Locations" column: with an elevation the cell links/opens
                                // the drawing (and flags custom prep locations); without one it shows the
                                // Standard/Custom prep status, which opens the Customize Hardware Locations dialog.
                                editable: {
                                    type: "custom",
                                    // copy the linked hardware id; paste adopts it server-side (see applyDrwElevationOps).
                                    copy: (data) => drwAdoptPayload("hardware", data.drwHardwareElevation),
                                    paste: (data, value) => {
                                        if(value === "") { clearDrwElevation("hardware", data); return; }
                                        applyDrwAdopt("hardware", data, value);
                                    },
                                    render: (props) => <PickHardwareElevation {...props} />,
                                },
                                // backspace/delete unlinks a drw hardware elevation (single-cell clear goes
                                // through editObj, not editable.paste; without this the cell has no editKey
                                // and clearing would error).
                                editObj: (dst, src, value: string) => {
                                    if(value === "") clearDrwElevation("hardware", dst);
                                },
                                isChangedSinceBackup: (row: Opening) => {
                                    if(row.drwHardwareElevationChanged) return true;
                                    if(!row.backup) return false;
                                    return row.drwHardwareElevation !== row.backup.drwHardwareElevation;
                                },
                                render: (data, col) => <HwElevationCell data={data} project={project} />,
                                filter: (data, search) => {
                                    return hwElevationCellString(data).toLowerCase().startsWith(search.toLowerCase());
                                },
                                sort: (a, b) => {
                                    return sortStringInner(hwElevationCellString(a), hwElevationCellString(b));
                                },
                                headerMenuItems: () => {
                                    return [{
                                        name: "Review Hardware Elevations",
                                        onClick: () => {
                                            props.onTabChange("review-drw-hardware-elevation")
                                        }
                                    }]
                                },
                            }, {
                                disabled: isWindow as any,
                            }),
                            showDoor && StatusCol("Door Status", "doorStatus"),
                            showFrame && StatusCol("Frame Status", "frameStatus"),
                            StringCol("Notes", "notes", 300),
                        ]}
                        fetch={async (ctx, ids) => {
                            console.log("opening-fetcher", ids)
                            const preview =  previewChangeset.enabled ? previewChangeset.sessionId : undefined;

                            if(ids) {
                                return api.openings.getByIds({
                                    project: project,
                                    ids: ids,
                                    previewChangeset: preview,
                                });
                            }

                            const all = await getAll(ctx, offset => api.openings.list({
                                project: project,
                                offset,
                                previewChangeset: preview,
                            }))

                            if(props.onlyConflicts) {
                                return all.filter(o => o.logictrl?.conflictsWithMain);
                            }

                            return all;
                        }}
                        fetchDeps={[project, props.onlyConflicts]}
                        insert={previewChangeset.enabled ? undefined : {
                            buttonText: "New Row",
                            alignX: "left",
                            modal: input => <AutoInsertOpening onDone={input} />,
                            options: () => <NewRowMenu />,
                        }}
                        onBulkChange={previewChangeset.enabled ? undefined : async (input, previous) => {
                            // elevation copy/paste column-fill: adopt each target via the drw endpoints
                            // (never the plain upsert — screen adopts identity, hardware clones). Rows
                            // without an adopt intent upsert as usual.
                            let didDrwOp = false;
                            const rows: Opening[] = [];
                            for(let i = 0; i < input.length; i++) {
                                if(hasDrwElevationOp(input[i])) {
                                    await applyDrwElevationOps(input[i]);
                                    didDrwOp = true;
                                } else {
                                    rows.push(openingAutoFill(input[i], previous[i]));
                                }
                            }

                            const result = rows.length > 0 ? await api.openings.bulkUpsert(rows) : null;
                            // adopt/unlink change rows server-side without returning ids; force a full reload.
                            return didDrwOp ? null : result;
                        }}
                        onChange={previewChangeset.enabled ? undefined : async (input, previous) => {
                            // elevation copy/paste + clear (single cell): adopt/unlink via the drw
                            // endpoints, not the plain opening upsert.
                            if(hasDrwElevationOp(input)) {
                                await applyDrwElevationOps(input);
                                return null; // reload to show the linked/cleared elevation
                            }

                            // Two independent server-side confirm gates: a wall-type cascade and a shared
                            // screen-elevation identity change. Each re-submits with an extra flag; recurse
                            // so a combined edit that trips one gate then the other resolves both.
                            const upsertWithConfirms = async (row: Opening & {userApprovedMultiEdit?: boolean; identityResolution?: "update-all" | "detach"}): Promise<any> => {
                                try {
                                    return await api.openings.upsert(row);
                                } catch (e: any) {
                                    const wallTypeNames: string[] | undefined = e?.raw?.details?.userConfirmUpdateOtherOpeningsForWallType;
                                    if (wallTypeNames?.length) {
                                        const confirmed = await wallTypeConfirm.confirm(wallTypeNames);
                                        if (!confirmed) throw new Error(errShowNoSnackInTable);

                                        await upsertWithConfirms({...row, userApprovedMultiEdit: true});
                                        // the cascade changed other openings too, so returning a result without
                                        // an id/ids makes the table do a full reload instead of a targeted one.
                                        return null;
                                    }

                                    const identityConflict: {openings: string[]} | undefined = e?.raw?.details?.sharedIdentityConflict;
                                    if (identityConflict?.openings?.length) {
                                        const resolution = await sharedIdentityConfirm.confirm(identityConflict.openings);
                                        if (!resolution) throw new Error(errShowNoSnackInTable);

                                        await upsertWithConfirms({...row, identityResolution: resolution});
                                        // update-all fans out to other openings, detach forks this one's elevations —
                                        // either way return without an id/ids so the table does a full reload.
                                        return null;
                                    }

                                    throw e;
                                }
                            };

                            try {
                                input = openingAutoFill(input, previous);
                                return await upsertWithConfirms(input)
                            } catch (e: any) {
                                return await hwContext.onError(input, e, upsertWithConfirms)
                            }
                        }}
                    />}
                </WithChangesetMeta>
            </CheckboxProvider>
        </>
    )
}
